import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import raf from 'raf'
import styled from 'styled-components'
import {white} from '@modifi/colors'

const RawTable = styled.table`
  width: 100%;
  border-spacing: 0;
  background: ${white};
  margin-bottom: 70px;
`

export default class Table extends PureComponent {
  events = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load']

  subscribers = []

  rafHandle = null

  static childContextTypes = {
    subscribe: PropTypes.func,
    unsubscribe: PropTypes.func,
    getParent: PropTypes.func,
  }

  getChildContext() {
    return {
      subscribe: this.subscribe,
      unsubscribe: this.unsubscribe,
      getParent: this.getParent,
    }
  }

  componentDidMount() {
    this.events.forEach(event => window.addEventListener(event, this.notifySubscribers))
  }

  componentWillUnmount() {
    if (this.rafHandle) {
      raf.cancel(this.rafHandle)
      this.rafHandle = null
    }

    this.events.forEach(event => window.removeEventListener(event, this.notifySubscribers))
  }

  subscribe = handler => {
    this.subscribers = this.subscribers.concat(handler)
  }

  unsubscribe = handler => {
    this.subscribers = this.subscribers.filter(current => current !== handler)
  }

  notifySubscribers = evt => {
    if (!this.framePending) {
      const {currentTarget} = evt

      this.rafHandle = raf(() => {
        this.framePending = false
        const {top, bottom} = this.node.getBoundingClientRect()

        this.subscribers.forEach(handler =>
          handler({
            distanceFromTop: top,
            distanceFromBottom: bottom,
            eventSource: currentTarget === window ? document.body : this.node,
          })
        )
      })
      this.framePending = true
    }
  }

  getParent = () => this.node

  render() {
    return (
      <RawTable
        {...this.props}
        ref={node => {
          this.node = node
        }}
        onScroll={this.notifySubscribers}
        onTouchStart={this.notifySubscribers}
        onTouchMove={this.notifySubscribers}
        onTouchEnd={this.notifySubscribers}
      />
    )
  }
}
